import { type JSX, useMemo } from 'react';

import { NoContent } from '@cx-modules/ui';

import { type Bet } from '../../types';
import { MarketExpanderBet } from '../MarketExpanderBet';

import { ExpanderBestOddsContent, ExpanderBestOddsRow, ExpanderBestOddsWrapper } from './style';

interface MarketExpanderGroupedProps {
  groupedBets: {
    [betName: string]: Array<
      Bet & {
        bestOdds: number;
        bestOddsFractional: string;
        bestOddsText: string | number;
      }
    >;
  };
}

export const MarketExpanderGrouped = ({ groupedBets }: MarketExpanderGroupedProps): JSX.Element => {
  const numberOfColumns = Object.keys(groupedBets).length;

  const numberOfVisibleRows = useMemo(() => {
    return Math.max(...Object.values(groupedBets).map(bets => bets.length));
  }, [groupedBets]);
  const homeTeamName = 'home';
  const awayTeamName = 'away';

  const sorted = Object.entries(groupedBets).sort(([betNameA], [betNameB]) => {
    if (betNameA === homeTeamName || betNameB === awayTeamName) {
      return -1;
    }
    if (betNameA === awayTeamName || betNameB === homeTeamName) {
      return 1;
    }
    return 0;
  });

  const showNoContent = sorted.length === 0;
  if (showNoContent) return <NoContent>No odds available at the moment. Check again later.</NoContent>;

  return (
    <ExpanderBestOddsWrapper>
      {[...Array(numberOfVisibleRows).keys()].map(rowIndex => (
        <ExpanderBestOddsRow key={rowIndex}>
          <ExpanderBestOddsContent numberOfColumns={numberOfColumns}>
            {sorted.map(([_, bets], columnIndex) => {
              const bet = bets[rowIndex];
              if (!bet) return null;
              return <MarketExpanderBet bet={bet} isFirst={rowIndex === 0 && columnIndex === 0} key={bet.id} />;
            })}
          </ExpanderBestOddsContent>
        </ExpanderBestOddsRow>
      ))}
    </ExpanderBestOddsWrapper>
  );
};
